/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { Module } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
import { IProductDescriptionViewProps } from './farmlands-product-description';

const ProductDescriptionView: React.FC<IProductDescriptionViewProps> = props => {
    const {
        ProductDescription,
        ProductDescriptionNode
    } = props;

    return (
        <Module {...ProductDescription}>
            {ProductDescriptionNode}
        </Module>
    );
};

export default ProductDescriptionView;